import React from 'react';
import { MailTemplateOptionType } from 'helper/mailer';
import Selector from 'components/DesignSystem/Selector';

export default function SubtypeSelect({
  subtypes,
  subtypeId,
  setSubtypeId,
  isValid,
}: {
  subtypes: MailTemplateOptionType[],
  subtypeId: number,
  setSubtypeId: (value: React.SetStateAction<number>) => void,
  isValid: boolean,
}) {
  return (
    <Selector
      id="subtype-select"
      label="Subtipo"
      value={subtypeId}
      setValue={setSubtypeId}
      isValid={isValid}
    >
      {subtypes.map((subtype) => (
        <option value={subtype.id} key={subtype.id}>{subtype.label}</option>
      ))}
    </Selector>
  );
}
